// Cabinet больше не использует service worker: precache Workbox сохранял
// index.html со ссылкой на хэшированный entry-бандл, который после следующей
// сборки отвечал 404 — страница оставалась пустой.
//
// Основную миграцию делает src/service-worker.js. Здесь — подстраховка на
// случай, когда страница загрузилась в обход старого воркера: снимаем
// оставшиеся регистрации и чистим их Cache Storage, иначе он остаётся висеть.
// Cookies и localStorage не трогаем — пользовательская сессия сохраняется.
if (process.env.NODE_ENV === 'production') {
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister())
  })

  window.caches?.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => caches.delete(cacheName))
  })
}
